import Image from 'next/image';

import { NextLink } from '@/atoms';
import { Button, VoteButton } from '@/molecules';

import { removeBaseURL } from '@/lib/utils';
import FallBackIMG from '@/assets/images/fallback-product-card.jpg';

import type { FunctionComponent } from 'react';
import type { TypeVoteSellerProps } from './types';

/**
 * VoteSeller
 */
export const VoteSeller: FunctionComponent<TypeVoteSellerProps> = ({
  description,
  name,
  image,
  link,
  pills,
  voteActive,
  voteData,
}: TypeVoteSellerProps) => (
  <div className="u-wrapper flex flex-col gap-5 md:flex-row md:gap-7">
    <Image
      src={image ? image.sourceUrl : FallBackIMG.src}
      alt={image ? image.altText : ''}
      width={image ? image.mediaDetails.width : FallBackIMG.width}
      height={image ? image.mediaDetails.height : FallBackIMG.height}
      className="object-cover"
      draggable={false}
    />

    <div className="flex w-full flex-col justify-between gap-2.5 md:gap-5">
      <p className="font-tertiary text-4xl text-typo-primary">{name}</p>

      {pills && pills.length > 0 && (
        <div className="flex flex-row flex-wrap gap-2">
          {pills
            .filter(({ title }) => title)
            .map((pill, index) => (
              <span
                key={index}
                className="rounded-2xl border border-primary-900 p-1 px-3 font-tertiary text-sm/normal text-typo-primary md:text-base"
              >
                {pill.title}
              </span>
            ))}
        </div>
      )}

      <div className={`flex flex-col ${description ? 'flex-1' : ''} gap-6`}>
        {description && (
          <p className="u-body u-body--m grow md:u-body--l">{description}</p>
        )}

        <div className="flex justify-between gap-5">
          <NextLink href={removeBaseURL(link) ?? '/'} passHref>
            <Button as="a" variant="primary" className="w-full !max-w-[150px]">
              VER PRODUCTOS
            </Button>
          </NextLink>

          {voteActive && <VoteButton {...voteData} />}
        </div>
      </div>
    </div>
  </div>
);

VoteSeller.displayName = 'VoteSeller';
